function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createFromIconfontCN } from '@ant-design/icons';
import { ConfigProvider, Image } from 'antd';
import classnames from 'classnames';
import React from 'react';

// 组件自己的样式
import { antdTheme } from "../theme";
import "./styles/card-type.less";
import "./styles/index.less";
import pic_error from "./assets/pic_error.png";
//import newPng from './assets/new.png';

var IconFont = createFromIconfontCN({
  scriptUrl: ['//at.alicdn.com/t/c/font_3963344_t4db2uwtyl.js']
});
var ListCard = function ListCard(props) {
  // njoyd 原生主题对象
  // antd 原生主题对象
  var antd = antdTheme(props.theme);
  //const njoyd = njoydTheme();

  var style = props.style,
    _props$kind = props.kind,
    kind = _props$kind === void 0 ? 'picture' : _props$kind,
    _props$statusType = props.statusType,
    statusType = _props$statusType === void 0 ? 'info' : _props$statusType,
    _props$actionsNode = props.actionsNode,
    actionsNode = _props$actionsNode === void 0 ? '' : _props$actionsNode,
    videoTime = props.videoTime,
    _props$src = props.src,
    src = _props$src === void 0 ? '' : _props$src,
    _props$picError = props.picError,
    picError = _props$picError === void 0 ? pic_error : _props$picError,
    iconText = props.iconText,
    iconSrc = props.iconSrc,
    _props$iconColor = props.iconColor,
    iconColor = _props$iconColor === void 0 ? true : _props$iconColor,
    metaStatusText = props.metaStatusText,
    metaTextExplain = props.metaTextExplain,
    metaTitle = props.metaTitle,
    handleDelete = props.handleDelete;

  // 右上角状态标
  var typeClassName = classnames(_defineProperty({
    njoy_item_card_cover_status: true
  }, "njoy_card_cover_status_".concat(statusType), true));

  // 左下角状态圆圈
  var typeIconClassName = classnames(_defineProperty({
    njoy_item_card_circle: true
  }, "njoy_card_cover_status_".concat(statusType), true));
  return /*#__PURE__*/React.createElement(ConfigProvider, {
    theme: {
      token: antd
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: _objectSpread({}, style),
    className: "njoy_item_card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "njoy_item_card_cover"
  }, iconSrc && /*#__PURE__*/React.createElement("div", {
    className: "njoy_item_card_icon"
  }, /*#__PURE__*/React.createElement("img", {
    src: iconSrc,
    alt: ""
  })), iconText && /*#__PURE__*/React.createElement("div", {
    className: typeClassName,
    title: iconText
  }, iconText), /*#__PURE__*/React.createElement(Image, {
    height: "100%",
    src: src,
    preview: false,
    fallback: picError
  }), kind === 'video' && /*#__PURE__*/React.createElement("div", {
    className: "njoy_card_cover_explain"
  }, videoTime || '00:00')), /*#__PURE__*/React.createElement("div", {
    className: "njoy_item_card_meta"
  }, metaTitle && /*#__PURE__*/React.createElement("div", {
    className: "njoy_item_card_line1"
  }, /*#__PURE__*/React.createElement("p", null, metaTitle), /*#__PURE__*/React.createElement("p", null, actionsNode || /*#__PURE__*/React.createElement(IconFont, {
    type: "icon-delete1",
    onClick: handleDelete
  }))), metaStatusText && /*#__PURE__*/React.createElement("div", {
    className: "njoy_item_card_line2"
  }, /*#__PURE__*/React.createElement("p", null, iconColor && /*#__PURE__*/React.createElement("span", {
    className: typeIconClassName
  }), ' ', metaStatusText), /*#__PURE__*/React.createElement("p", null, metaTextExplain)))));
};
export default ListCard;